import type { JSX } from "react";
import { useSearchParams } from "react-router-dom";

import { SidebarItem, SidebarSection } from "../../common/components/SidebarNav.js";
import { ADMIN_SECTIONS, findSection } from "../adminSections.js";

/** Sidebar der Administration: die Bereiche des Mandanten. */
export function AdminSidebar(): JSX.Element {
  const [params, setParams] = useSearchParams();
  const active = findSection(params.get("section"));

  return (
    <SidebarSection title="Administration">
      {ADMIN_SECTIONS.map((section) => (
        <SidebarItem
          key={section.id}
          label={section.name}
          active={section.id === active.id}
          onClick={() =>
            setParams((current) => {
              const updated = new URLSearchParams(current);
              updated.set("section", section.id);
              return updated;
            })
          }
        />
      ))}
    </SidebarSection>
  );
}
